import {
  ADMIN,
  TEACHER,
  PARENT,
  STUDENT,
  ASSISTANT,
  ECE,
  PAGES,
  COMPONENTS,
} from '@BUP/constants';

const rules = {
  [PAGES]: {
    HomePage: {
      route: '/',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER, ASSISTANT],
    },
    CoursePage: {
      route: '/course',
      roles: [TEACHER],
    },
    ProfilePage: {
      route: '/profile',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER, ASSISTANT],
    },
    WebinarsPage: {
      route: '/webinars',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER, ASSISTANT],
    },
    ResourcesPage: {
      route: '/resources',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER, ASSISTANT],
    },
    ResourcesByIdPage: {
      route: '/resources/:resourceId',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER, ASSISTANT],
    },
    TopicsPage: {
      route: '/resources/:resourceId/level/:levelId',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER, ASSISTANT],
    },
    TopicDetailPage: {
      route: '/resources/:resourceId/level/:levelId/topic/:topicId',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER, ASSISTANT],
    },
    BupSendPage: {
      route: '/modebup/send',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER, ASSISTANT],
    },
    BupInboxPage: {
      route: '/modebup/inbox',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER, ASSISTANT],
    },
    BupDirectPage: {
      route: '/modebup/direct',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER, ASSISTANT],
    },
    BupArchivedPage: {
      route: '/modebup/archived',
      roles: [ECE, ADMIN],
    },
    DataPage: {
      route: '/data',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER, ASSISTANT],
    },
    DataInstrumentsPage: {
      route: '/data/instruments',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER, ASSISTANT],
    },
    DataActiveInstrumentsPage: {
      route: '/data/active-instruments',
      roles: [ADMIN, ECE],
    },
    DataConfirmSurveyPage: {
      route: '/data/confirm-survey',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER, ASSISTANT],
    },
    DataDesertSurveyPage: {
      route: '/data/confirm-survey/desert-survey',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER, ASSISTANT],
    },
    DataSurveyPage: {
      route: '/data/confirm-survey/survey',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER, ASSISTANT],
    },
    DataTrackingPage: {
      route: '/data/tracking',
      roles: [ADMIN, ECE],
    },
    DataAdvanceStatusPage: {
      route: '/data/tracking/advance-status',
      roles: [ADMIN, ECE],
    },
    DataActivationStepsPage: {
      route: '/data/instruments/activation-steps',
      roles: [ADMIN, ECE],
    },
    DataStartActivationPage: {
      route: '/data/instruments/request-activation/start-activation',
      roles: [ADMIN, ECE],
    },
    DataTermsAndConditionsPage: {
      route:
        '/data/instruments/request-activation/start-activation/terms-and-conditions',
      roles: [ADMIN, ECE],
    },
    DataResultsReportPage: {
      route: '/data/tracking/results-report',
      roles: [ADMIN, ECE],
    },
    DashboardPage: {
      route: '/data/dashboard',
      roles: [ADMIN, ECE],
    },
    CourseView: {
      route: '/data/dashboard/course/:courseId',
      roles: [ADMIN, ECE],
    },
    // UserProfileById: {
    //   route: '/data/dashboard/student-profile/:studentId',
    //   roles: [ADMIN, ECE],
    // },
    SociogramPage: {
      route: '/data/sociogram',
      roles: [STUDENT],
    },
    SociogramPageById: {
      route: '/data/sociogram/:pageId',
      roles: [STUDENT],
    },
    SociogramFinishedPage: {
      route: '/data/sociogram/finish',
      roles: [STUDENT],
    },
    ActiveSociogramPage: {
      route: '/data/active-sociogram',
      roles: [TEACHER],
    },
  },

  [COMPONENTS]: {
    navModeBupSendLink: {
      roles: [PARENT, STUDENT, TEACHER, ASSISTANT],
    },
    navModeBupArchivedLink: {
      roles: [ADMIN, ECE],
    },
    openOrCloseMessageButton: {
      roles: [ADMIN, ECE],
    },
    messageListStateTag: {
      roles: [PARENT, STUDENT, TEACHER, ASSISTANT],
    },
    navWebinars: {
      roles: [ADMIN, ECE, PARENT, TEACHER, ASSISTANT],
    },
    // navData: {
    //   roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER, ASSISTANT],
    // },
  },
};

export const checkPagePermissions = (pageName, user, path) => {
  const userRole = user?.roles?.type;
  if (!userRole || !pageName || !path) return false;
  const pageRule = rules[PAGES][pageName];
  if (!pageRule) return false;
  const routePermissions = pageRule.route === path;
  const pageRoles = pageRule.roles;
  const rolePermissions = pageRoles && pageRoles.includes(userRole);
  // console.log("routePermissions", routePermissions)
  // console.log("rolesPermissions", rolePermissions)
  return routePermissions && rolePermissions;
};

export const checkComponentPermissions = (userRole, componentName) => {
  if (!userRole || !componentName) return false;
  const componentRule = rules[COMPONENTS][componentName];
  if (!componentRule) return false;
  const componentRoles = componentRule.roles;
  // console.log("checkComponentPermissions", userRole, componentName, componentRule)
  const rolePermissions = componentRoles && componentRoles.includes(userRole);
  return rolePermissions;
};
